
export const catsData = [
  {
    id: 1,
    name: "Luna",
    age: "2 years",
    gender: "Female",
    breed: "Domestic Shorthair",
    color: "Black & White",
    personality: "Playful, Affectionate, Good with kids",
    description: "Luna is a sweet and playful cat who loves to chase toys and cuddle. She's great with children and other cats.",
    spayNeuter: "Spay required",
    cost: "$150",
    image: "https://public.readdy.ai/ai/img_res/628536bcfa8955c51d0a02efbb419e29.jpg"
  },
  {
    id: 2,
    name: "Whiskers",
    age: "4 years",
    gender: "Male",
    breed: "Maine Coon Mix",
    color: "Orange Tabby",
    personality: "Calm, Gentle, Lap cat",
    description: "Whiskers is a gentle giant who loves to sit on laps and purr. He's very calm and would be perfect for a quiet home.",
    spayNeuter: "Neuter required",
    cost: "$175",
    image: "https://readdy.ai/api/search-image?query=Handsome%20orange%20tabby%20Maine%20Coon%20mix%20cat%20with%20long%20fluffy%20fur%20sitting%20peacefully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20lighting%2C%20gentle%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=whiskers2&orientation=squarish"
  },
  {
    id: 3,
    name: "Mittens",
    age: "1 year",
    gender: "Female",
    breed: "Calico",
    color: "Calico",
    personality: "Energetic, Curious, Social",
    description: "Mittens is a young and energetic calico who loves to explore and play. She's very social and gets along well with other pets.",
    spayNeuter: "Spay required",
    cost: "$125",
    image: "https://readdy.ai/api/search-image?query=Adorable%20young%20calico%20cat%20with%20beautiful%20tri-color%20pattern%20sitting%20alertly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%20style%2C%20bright%20natural%20lighting%2C%20curious%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=mittens3&orientation=squarish"
  },
  {
    id: 4,
    name: "Shadow",
    age: "3 years",
    gender: "Male",
    breed: "Domestic Longhair",
    color: "Gray",
    personality: "Independent, Quiet, Observant",
    description: "Shadow is a beautiful gray longhair who prefers a quieter environment. He's independent but loving once he trusts you.",
    spayNeuter: "Neuter required",
    cost: "$160",
    image: "https://readdy.ai/api/search-image?query=Elegant%20gray%20longhair%20domestic%20cat%20with%20fluffy%20coat%20sitting%20majestically%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20lighting%2C%20calm%20dignified%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=shadow4&orientation=squarish"
  },
  {
    id: 5,
    name: "Bella",
    age: "5 years",
    gender: "Female",
    breed: "Siamese Mix",
    color: "Seal Point",
    personality: "Vocal, Intelligent, Loyal",
    description: "Bella is a talkative Siamese mix who loves to 'chat' with her humans. She's very intelligent and forms strong bonds.",
    spayNeuter: "Spay required",
    cost: "$140",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Siamese%20mix%20cat%20with%20seal%20point%20coloring%20and%20bright%20blue%20eyes%20sitting%20elegantly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20natural%20lighting%2C%20alert%20intelligent%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=bella5&orientation=squarish"
  },
  {
    id: 6,
    name: "Tiger",
    age: "6 years",
    gender: "Male",
    breed: "Bengal Mix",
    color: "Brown Spotted",
    personality: "Active, Playful, Adventurous",
    description: "Tiger is an active Bengal mix who loves to climb and explore. He needs an experienced owner who can provide lots of enrichment.",
    spayNeuter: "Neuter required",
    cost: "$200",
    image: "https://readdy.ai/api/search-image?query=Stunning%20Bengal%20mix%20cat%20with%20brown%20spotted%20pattern%20and%20muscular%20build%20sitting%20proudly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20dramatic%20lighting%2C%20confident%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=tiger6&orientation=squarish"
  },
  {
    id: 7,
    name: "Snowball",
    age: "2 years",
    gender: "Female",
    breed: "Persian Mix",
    color: "White",
    personality: "Gentle, Quiet, Affectionate",
    description: "Snowball is a gentle Persian mix with beautiful long white fur. She's quiet and loves gentle pets and brushing.",
    spayNeuter: "Spay required",
    cost: "$180",
    image: "https://readdy.ai/api/search-image?query=Gorgeous%20white%20Persian%20mix%20cat%20with%20long%20fluffy%20fur%20and%20round%20face%20sitting%20gracefully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20lighting%2C%20sweet%20gentle%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=snowball7&orientation=squarish"
  },
  {
    id: 8,
    name: "Patches",
    age: "3 years",
    gender: "Male",
    breed: "Domestic Shorthair",
    color: "Tuxedo",
    personality: "Friendly, Social, Good with dogs",
    description: "Patches is a handsome tuxedo cat who gets along great with dogs and other cats. He's very social and friendly.",
    spayNeuter: "Neuter required",
    cost: "$145",
    image: "https://readdy.ai/api/search-image?query=Handsome%20tuxedo%20cat%20with%20black%20and%20white%20markings%20sitting%20confidently%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%20style%2C%20natural%20lighting%2C%20friendly%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=patches8&orientation=squarish"
  },
  {
    id: 9,
    name: "Ginger",
    age: "1 year",
    gender: "Female",
    breed: "Domestic Shorthair",
    color: "Orange",
    personality: "Playful, Sweet, Kitten-like",
    description: "Ginger is a young orange female (rare!) who still has lots of kitten energy. She's sweet and loves to play with toys.",
    spayNeuter: "Spay required",
    cost: "$130",
    image: "https://readdy.ai/api/search-image?query=Adorable%20young%20orange%20female%20cat%20with%20bright%20coat%20sitting%20playfully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20lighting%2C%20sweet%20kitten-like%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=ginger9&orientation=squarish"
  },
  {
    id: 10,
    name: "Smokey",
    age: "4 years",
    gender: "Male",
    breed: "Russian Blue Mix",
    color: "Blue-Gray",
    personality: "Shy, Gentle, Needs patience",
    description: "Smokey is a shy Russian Blue mix who needs a patient owner. Once he warms up, he's incredibly loving and gentle.",
    spayNeuter: "Neuter required",
    cost: "$155",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20blue-gray%20Russian%20Blue%20mix%20cat%20with%20dense%20coat%20sitting%20quietly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20lighting%2C%20gentle%20shy%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=smokey10&orientation=squarish"
  },
  {
    id: 11,
    name: "Coco",
    age: "2 years",
    gender: "Female",
    breed: "Chocolate Point Siamese",
    color: "Chocolate Point",
    personality: "Vocal, Affectionate, Attention-seeking",
    description: "Coco is a beautiful chocolate point Siamese who loves attention and will follow you around the house chatting.",
    spayNeuter: "Spay required",
    cost: "$165",
    image: "https://readdy.ai/api/search-image?query=Elegant%20chocolate%20point%20Siamese%20cat%20with%20cream%20body%20and%20brown%20points%20sitting%20gracefully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20natural%20lighting%2C%20alert%20vocal%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=coco11&orientation=squarish"
  },
  {
    id: 12,
    name: "Oreo",
    age: "3 years",
    gender: "Male",
    breed: "Domestic Shorthair",
    color: "Black & White",
    personality: "Laid-back, Easy-going, Cuddly",
    description: "Oreo is a laid-back black and white cat who loves to cuddle and nap in sunny spots. He's very easy-going.",
    spayNeuter: "Neuter required",
    cost: "$140",
    image: "https://readdy.ai/api/search-image?query=Relaxed%20black%20and%20white%20domestic%20shorthair%20cat%20with%20distinctive%20markings%20sitting%20calmly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20lighting%2C%20peaceful%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=oreo12&orientation=squarish"
  },
  {
    id: 13,
    name: "Princess",
    age: "5 years",
    gender: "Female",
    breed: "Ragdoll Mix",
    color: "Seal Point",
    personality: "Docile, Sweet, Lap cat",
    description: "Princess is a sweet Ragdoll mix who lives up to her name. She's very docile and loves to be held and petted.",
    spayNeuter: "Spay required",
    cost: "$190",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Ragdoll%20mix%20cat%20with%20seal%20point%20coloring%20and%20long%20fluffy%20fur%20sitting%20regally%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20lighting%2C%20sweet%20docile%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=princess13&orientation=squarish"
  },
  {
    id: 14,
    name: "Bandit",
    age: "2 years",
    gender: "Male",
    breed: "Domestic Shorthair",
    color: "Gray Tabby",
    personality: "Mischievous, Playful, Smart",
    description: "Bandit is a smart gray tabby who loves to get into (harmless) mischief. He's very playful and needs lots of toys.",
    spayNeuter: "Neuter required",
    cost: "$135",
    image: "https://readdy.ai/api/search-image?query=Playful%20gray%20tabby%20cat%20with%20distinctive%20stripes%20sitting%20alertly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20natural%20lighting%2C%20mischievous%20intelligent%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=bandit14&orientation=squarish"
  },
  {
    id: 15,
    name: "Daisy",
    age: "1 year",
    gender: "Female",
    breed: "Tortoiseshell",
    color: "Tortoiseshell",
    personality: "Sassy, Independent, Loving",
    description: "Daisy is a sassy tortoiseshell with lots of personality. She's independent but very loving on her own terms.",
    spayNeuter: "Spay required",
    cost: "$125",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20tortoiseshell%20cat%20with%20mixed%20brown%20and%20black%20coloring%20sitting%20confidently%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20lighting%2C%20sassy%20independent%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=daisy15&orientation=squarish"
  },
  {
    id: 16,
    name: "Max",
    age: "6 years",
    gender: "Male",
    breed: "Domestic Longhair",
    color: "Black",
    personality: "Mature, Calm, Gentle",
    description: "Max is a mature black longhair who would be perfect for someone looking for a calm, gentle companion.",
    spayNeuter: "Neuter required",
    cost: "$170",
    image: "https://readdy.ai/api/search-image?query=Majestic%20black%20longhair%20cat%20with%20thick%20fluffy%20coat%20sitting%20dignified%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20dramatic%20lighting%2C%20calm%20mature%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=max16&orientation=squarish"
  },
  {
    id: 17,
    name: "Lily",
    age: "3 years",
    gender: "Female",
    breed: "Domestic Shorthair",
    color: "Dilute Calico",
    personality: "Sweet, Gentle, Good with seniors",
    description: "Lily is a gentle dilute calico who would be perfect for a senior or someone looking for a calm companion.",
    spayNeuter: "Spay required",
    cost: "$150",
    image: "https://readdy.ai/api/search-image?query=Sweet%20dilute%20calico%20cat%20with%20soft%20pastel%20coloring%20sitting%20peacefully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20gentle%20lighting%2C%20calm%20loving%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=lily17&orientation=squarish"
  },
  {
    id: 18,
    name: "Rocky",
    age: "4 years",
    gender: "Male",
    breed: "Domestic Shorthair",
    color: "Brown Tabby",
    personality: "Confident, Outgoing, Social",
    description: "Rocky is a confident brown tabby who loves meeting new people. He's very outgoing and social.",
    spayNeuter: "Neuter required",
    cost: "$145",
    image: "https://readdy.ai/api/search-image?query=Confident%20brown%20tabby%20cat%20with%20bold%20stripes%20sitting%20proudly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20natural%20lighting%2C%20outgoing%20social%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=rocky18&orientation=squarish"
  },
  {
    id: 19,
    name: "Angel",
    age: "2 years",
    gender: "Female",
    breed: "White Domestic Shorthair",
    color: "Pure White",
    personality: "Angelic, Quiet, Loving",
    description: "Angel is a pure white beauty who lives up to her name. She's quiet, gentle, and incredibly loving.",
    spayNeuter: "Spay required",
    cost: "$160",
    image: "https://readdy.ai/api/search-image?query=Pure%20white%20domestic%20shorthair%20cat%20with%20pristine%20coat%20sitting%20angelically%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20ethereal%20lighting%2C%20gentle%20loving%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=angel19&orientation=squarish"
  },
  {
    id: 20,
    name: "Rusty",
    age: "5 years",
    gender: "Male",
    breed: "Domestic Longhair",
    color: "Orange & White",
    personality: "Friendly, Relaxed, Good with kids",
    description: "Rusty is a friendly orange and white longhair who loves children and is very relaxed and easy-going.",
    spayNeuter: "Neuter required",
    cost: "$175",
    image: "https://readdy.ai/api/search-image?query=Friendly%20orange%20and%20white%20longhair%20cat%20with%20fluffy%20coat%20sitting%20warmly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20lighting%2C%20relaxed%20friendly%20expression%2C%20high%20quality%20portrait&width=400&height=400&seq=rusty20&orientation=squarish"
  }
];
